import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import App from './components/App';
import { initRemoteMfes } from '../util/remoteUtils';
import { isBrowser } from '../util/routeUtils';

const render = () => {
  const { pageData = {}, sharedConfig = {} } = (window as any)?.csrData ?? {};
  const storeConf = (window as any)?.storeConf;
  const pageRoute = (window as any)?.location?.pathname;
  initRemoteMfes(pageData?.importMaps, false, pageRoute);

  const hydrationStart = performance.now();

  hydrateRoot(
    document.getElementById('root'),
    <CookiesProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App pageData={pageData} storeConf={storeConf} sharedConfig={sharedConfig} />
      </BrowserRouter>
    </CookiesProvider>,
  );

  if (isBrowser()) {
    setTimeout(() => {
      const hydrationEnd = performance.now();
      console.log('Hydration time:', hydrationEnd - hydrationStart, 'ms');
    }, 0);
  }
};

render();
